export default {
  namespaced: true,
  billing_holiday: {
    title: "Holidays",
    date: "Date",
  }
}